(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('ContentSearch', ContentSearch);

    ContentSearch.$inject = ['$resource'];

    function ContentSearch($resource) {
        var resourceUrl =  'api/_search/contents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
